import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SignupService } from '../../../services/signup.service';
import { AccountStatus } from '../../../models';

@Component({
  selector: 'signup-step5',
  templateUrl: './step5.component.html'
})
export class Step5Component implements OnInit {

  verified: boolean;
  ismobile: boolean;

  constructor(private route: ActivatedRoute, private signupService: SignupService) { }

  ngOnInit(): void {
    let sub = this.route.params
      .subscribe(params => this.accountVerification(params['token']));
  }

  private accountVerification(token: string) {
    this.signupService.verifyAccount(token)
      .subscribe(result => {
        this.verified = (result.accountStatus === AccountStatus.verified);
        this.ismobile = result.isMobile;
      });
  }

}
